import React from 'react'

const Logo = () => {
  return (
    <img src="/images/logo-negative.svg" alt="Logo" width={190} height={50} />
  )
}

export default Logo